<template>
  <div class="grid grid--widebookmarks">
    <div v-if="!user.parent" class="xs-12 m-4 l-3 bookmarks__sidebar">
      <component :is="sidebarComponent" v-if="showSidebar" :bookmark-types="bookmarkTypes"></component>
      <Buttons
        v-if="!showSidebar"
        class="dea-button--medium dea-button--full dea-button--show-filters"
        @click="showSidebar = true"
      >
        Mostra filtri
      </Buttons>
      <Buttons
        v-if="showSidebar"
        class="dea-button--medium dea-button--full dea-button--hide-filters"
        @click="showSidebar = false"
      >
        Nascondi filtri
      </Buttons>
    </div>
    <div class="xs-12 bookmarks__list" :class="user.parent ? 'm-12 l-12' : 'm-8 l-9'">
      <header class="bookmarks__header">
        <h2 class="bookmarks__title dea-heading--medium-xxl" tabindex="0">{{ mainTitle }}</h2>
      </header>
      <DeALiveList v-if="posts.length" :items="posts" @save-bookmark="addBookmark" @delete-bookmark="removeBookmark" />
      <EmptyDeAlive v-else :link-color="user.targetCss.colorMod" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DeALiveList from "@/components/patterns/DeALiveList";
import Buttons from "deascuola-storybook/src/components/elements/Buttons";
import handleWindowResize from "deascuola-storybook/src/components/mixins/handleWindowResize";
import BookmarkActions from "~/components/bookmarks/mixins/BookmarkActions";
import EmptyDeAlive from "~/components/bookmarks/components/EmptyDeALive";
import BookmarkTypeView from "~/components/bookmarks/mixins/BookmarkTypeView";
import setFocus from "~/helpers/setFocus";

export default {
  name: "BookmarksDeALive",
  components: { EmptyDeAlive, DeALiveList, Buttons },
  mixins: [BookmarkActions, handleWindowResize, BookmarkTypeView],

  computed: {
    ...mapGetters(["posts", "config"]),
  },
  mounted() {
    setFocus("bookmarks__title");
  },
  activated() {
    setFocus("bookmarks__title");
  },
};
</script>
